export class parameters {
    constructor() {
    }
    static getInstance() {
        if (!parameters.instance) {
            parameters.instance = new parameters();
        }
        return parameters.instance;
    }
    getNonce() {
        return this._nonce;
    }
    setNonce(nonce) {
        this._nonce = nonce;
    }
    getReturnUrl() {
        return this._returnUrl;
    }
    setReturnUrl(url) {
        this._returnUrl = url;
    }
}
